import React from 'react'
import styled from 'styled-components'
import { type SpaceProps } from 'styled-system'
import { Text } from 'components/Typography'
import { COLOR_INTENT, FONT_SIZE, SPACE } from 'Theme'

interface ProductOptionRowProps extends SpaceProps {
  name: string
  value: string
}

export const ProductDetailDescription = styled(Text)`
  font-size: ${FONT_SIZE.PX_12};
  color: ${COLOR_INTENT.GRAY_70};
`

export const ProductOptionRow: React.FC<React.PWC<ProductOptionRowProps>> = ({
  name,
  value,
  ...rest
}) => (
  <ProductDetailDescription {...rest}>
    <Text fontSize={FONT_SIZE.PX_12} mb={SPACE.PX_4} textTransform="capitalize">
      {name}:{' '}
    </Text>
    <Text fontSize={FONT_SIZE.PX_12}>{value}</Text>
  </ProductDetailDescription>
)
